<template>
  <div class="navigation">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-7 col-xs-6">
          <bread-crumbs @toggle="$emit('toggle')" />
        </div>

        <div class="col-md-5 col-xs-6">
          <div class="links">
            <ul>
              <li>
                <div class="dropdown text-capitalize">
                  <p
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                  >
                    <img
                      src="/defaults/user.png"
                      alt="User"
                    >
                    {{ first_name }}
                    <small>({{ role }})</small>
                    <span class="caret" />
                  </p>
                  <ul class="dropdown-menu dropdown-menu-right">
                    <li>
                      <a @click.prevent="$router.push({ name: 'profile.info'})">My Account</a>
                    </li>
                    <li><a @click.prevent="logout">Log out</a></li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import BreadCrumbs from "@/components/Dashboard/BreadCrumbs";

    export default {
        components: {
            BreadCrumbs
        },
        computed: {
            first_name() {
                return this.$store.getters.getAuthUser.firstname;
            },

            role() {
                return this.$store.getters.getAuthUser.role;
            }
        },
        mounted() {
          this.initiate();
        },
        methods: {
            logout() {
                this.$axios.post('/api/v1/logout').finally(() => {
                    this.$auth.logout();
                    window.location.href = this.$router.resolve({name: 'home'}).href;
                });
            },
            initiate() {
                if (this.first_name) return;
                this.$store.dispatch('initialize');
            },

        }
    }
</script>

<style lang="scss">
    @import "../../styles/variables";
    aside{
      display: block;
      width: 200px;
      background: #cecece;
      height: 100vh;
    }
    .active{
      display: block;
    }

    .navigation {
        background: $sidgray;
        .links {
            padding-top: 10px;
            float: right;

            @media (max-width: 480px) {
                float: left;
            }

            ul {
                list-style: none;
                padding: 0;

                li {
                    display: inline-block;

                    div.dropdown{
                        ul.dropdown-menu{
                            background: #414b55;
                        }
                        ul.dropdown-menu li{
                            display: block;
                        }
                        img {
                            height: 40px;
                            width: auto;
                        }

                        p{
                            color: $yellow;
                            cursor: pointer;
                        }

                        li {
                            a {
                                display: block;
                                padding: 10px;
                                color: #f7f201;
                                cursor: pointer;
                            }
                        }
                    }

                    a {
                        display: block;
                        &.user {
                            color: $yellow;

                            img {
                                height: 40px;
                                width: auto;
                            }

                            ul {
                                position: absolute;
                                border: 1px solid #aaa;
                                width: 150px;
                                right: 10px;
                                margin-top: 5px;
                                z-index: 99999;
                                display: none;
                                background: $sidgray;

                                @media(max-width: 480px) {
                                    left: 10px;
                                }

                                li {
                                    a {
                                        display: block;
                                        padding: 10px;
                                        color: #f7f201;
                                    }
                                }
                            }

                            &:focus {
                                ul {
                                    display: block;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
